/**
 * Jaipur Handloom AE8 component owner
 * File: jh-60-product-sharing.js
 * Owns: product-specific WhatsApp copy, language submission and review-summary text.
 * Depends on: product variant events from jh-20-search-collection.js.
 * Mobile trust visibility is CSS-owned; cart and generic share behavior are not owned here.
 */
(function() {
  'use strict';

  var JH = window.JH = window.JH || {};
  var U = JH.Utils;

  function qs(selector, root) {
    return U ? U.qs(selector, root) : (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return U ? U.qsa(selector, root) : Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function parseJson(element) {
    try {
      return JSON.parse((element && element.textContent) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function absoluteUrl(source) {
    source = String(source || '').trim();
    if (!source) return '';
    if (source.indexOf('//') === 0) return window.location.protocol + source;
    try {
      return new URL(source, window.location.origin).toString();
    } catch (error) {
      return source;
    }
  }

  function money(cents) {
    return U ? U.money(cents) : (Number(cents || 0) / 100).toFixed(2);
  }

  function selectedOptions(root) {
    var selected = [];
    qsa('[data-jh-option-group]', root).forEach(function(group) {
      var position = (parseInt(group.getAttribute('data-position') || '1', 10) || 1) - 1;
      var select = qs('[data-jh-option-select]', group);
      var button = qs('[data-jh-option].is-selected', group) || qs('[data-jh-option]', group);
      selected[position] = select ? select.value : (button ? button.getAttribute('data-value') || button.textContent.trim() : '');
    });
    return selected.filter(Boolean);
  }

  function currentVariant(root, product) {
    var hidden = qs('[data-jh-variant-id]', root);
    var variants = product.variants || [];
    if (hidden && hidden.value) {
      var byId = variants.find(function(variant) { return String(variant.id) === String(hidden.value); });
      if (byId) return byId;
    }
    var selected = selectedOptions(root).join('||');
    return variants.find(function(variant) { return (variant.options || []).join('||') === selected; }) || variants[0] || {};
  }

  function variantLabel(root, variant) {
    if (variant && variant.title && variant.title !== 'Default Title') return variant.title;
    var selected = selectedOptions(root);
    return selected.length ? selected.join(' / ') : 'Default option';
  }

  function variantImage(root, product, variant) {
    var image = '';
    if (variant && variant.featured_image) {
      image = variant.featured_image.src || variant.featured_image.url || variant.featured_image.preview_image || '';
    }
    if (!image && product.featured_image) {
      image = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src || product.featured_image.url || '';
    }
    if (!image) image = root.getAttribute('data-jh-product-image') || '';
    if (!image) {
      var current = qs('[data-jh-main-media] img', root);
      if (current) image = current.currentSrc || current.src || '';
    }
    return absoluteUrl(image);
  }

  function productUrl(root, variant) {
    try {
      var url = new URL(root.getAttribute('data-jh-product-url') || window.location.href, window.location.origin);
      if (variant && variant.id) url.searchParams.set('variant', variant.id);
      return url.toString();
    } catch (error) {
      return window.location.href;
    }
  }

  function buildWhatsAppMessage(root) {
    var product = parseJson(qs('[data-jh-product-json]', root));
    var variant = currentVariant(root, product);
    var quantityInput = qs('[data-jh-product-qty]', root);
    var quantity = quantityInput ? Math.max(parseInt(quantityInput.value || '1', 10) || 1, 1) : 1;
    var heading = qs('h1', root);
    var title = product.title || (heading ? heading.textContent.trim() : document.title);
    var price = variant.price != null ? money(variant.price) : ((qs('[data-jh-current-price]', root) || {}).textContent || '').trim();
    var lines = [
      'Hi Jaipur Handloom, I need help with this product:',
      '',
      'Product: ' + title,
      'Selected size / variant: ' + variantLabel(root, variant),
      'Price: ' + (price || 'Please confirm'),
      'Quantity: ' + quantity,
      'Product link: ' + productUrl(root, variant)
    ];
    var image = variantImage(root, product, variant);
    if (image) lines.push('Product photo: ' + image);
    return lines.join('\n');
  }

  function updateWhatsAppLinks(root) {
    if (!root) return;
    var message = buildWhatsAppMessage(root);
    qsa('a[href*="wa.me"],a[href*="whatsapp.com"]').forEach(function(link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (url.hostname.indexOf('wa.me') === -1 && url.hostname.indexOf('whatsapp.com') === -1) return;
        url.searchParams.set('text', message);
        link.href = url.toString();
        link.setAttribute('data-jh-whatsapp-product-details', 'true');
      } catch (error) {}
    });
  }

  function initProductSharing(scope) {
    var root = qs('[data-jh-product-root]', scope || document) || qs('[data-jh-product-root]');
    if (!root) return;
    updateWhatsAppLinks(root);
    if (root.dataset.jhWhatsAppReady === 'true') return;
    root.dataset.jhWhatsAppReady = 'true';
    var schedule = U ? U.debounce(function() { updateWhatsAppLinks(root); }, 0) : function() { updateWhatsAppLinks(root); };
    ['change', 'input'].forEach(function(eventName) { root.addEventListener(eventName, schedule, true); });
  }

  function initLanguageSelectors(scope) {
    qsa('[data-jh-language-select]', scope || document).forEach(function(select) {
      if (select.dataset.jhLanguageReady === 'true') return;
      select.dataset.jhLanguageReady = 'true';
      select.addEventListener('change', function() {
        if (select.form) select.form.submit();
      });
    });
  }

  function parseReviewCount(text) {
    text = String(text || '').replace(/,/g, ' ');
    var match = text.match(/(\d+)\s*(?:customer\s*)?reviews?/i) ||
      text.match(/reviews?\s*\(?\s*(\d+)\s*\)?/i) || text.match(/\((\d+)\)/);
    return match && match[1] ? parseInt(match[1], 10) || 0 : 0;
  }

  function normalizeReviewSummary() {
    var link = qs('[data-jh-review-summary-link]');
    var label = link && qs('[data-jh-review-summary-text]', link);
    if (!link || !label) return;
    var text = [
      link.getAttribute('data-jh-judge-badge-text') || '',
      (qs('.jh-review-summary-source') || {}).textContent || '',
      (qs('.jh-product-media-reviews .jdgm-prev-badge__text') || {}).textContent || '',
      (qs('.jh-product-media-reviews .jdgm-rev-widg__summary-text') || {}).textContent || '',
      (qs('.jh-product-media-reviews .jdgm-widget') || {}).textContent || ''
    ].join(' ');
    var count = parseReviewCount(text);
    label.textContent = count > 0 ? count + ' Reviews' : 'Reviews';
    link.setAttribute('aria-label', count > 0 ? 'Read ' + count + ' product reviews' : 'Read product reviews');
  }

  function forceWhatsAppShareLabel(scope) {
    var root = qs('[data-jh-product-root]', scope || document) || qs('[data-jh-product-root]');
    if (!root) return;
    qsa('.jh-product-share', root).forEach(function(box) {
      qsa('span', box).forEach(function(span) {
        if (/share/i.test(span.textContent || '')) span.textContent = 'WhatsApp';
      });
      qsa('a,button', box).forEach(function(element) {
        var text = (element.textContent || '').trim();
        if (/^(share|more share options|send product details)$/i.test(text)) element.textContent = 'WhatsApp';
      });
    });
  }

  function init(scope) {
    initProductSharing(scope);
    initLanguageSelectors(scope);
    normalizeReviewSummary();
    forceWhatsAppShareLabel(scope);
    window.setTimeout(normalizeReviewSummary, 400);
    window.setTimeout(normalizeReviewSummary, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); }, { once: true });
  } else init(document);

  document.addEventListener('variant:change', function(event) {
    updateWhatsAppLinks(event.detail && event.detail.root ? event.detail.root : qs('[data-jh-product-root]'));
  });
  document.addEventListener('shopify:section:load', function(event) {
    window.setTimeout(function() { init(event.target); }, 100);
  });
})();
